function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.929 11.51a6.68 6.68 0 0 0 2.06-4.828 6.68 6.68 0 0 0-2.055-4.823c3.626 1.35 5.864 3.958 6.527 4.823-.662.867-2.897 3.48-6.532 4.828zm-4.575.826c-3.096 0-5.615-2.537-5.615-5.654 0-3.118 2.519-5.654 5.615-5.654s5.615 2.536 5.615 5.654c0 3.117-2.52 5.654-5.615 5.654zM1.246 6.68c.663-.866 2.898-3.48 6.533-4.827a6.68 6.68 0 0 0-2.061 4.828 6.68 6.68 0 0 0 2.055 4.823C4.148 10.155 1.91 7.546 1.246 6.68zm23.273-.284C24.346 6.135 20.194 0 12.354 0 4.514 0 .362 6.135.189 6.397L0 6.682l.189.285c.173.261 4.325 6.397 12.165 6.397 7.84 0 11.992-6.136 12.165-6.397l.189-.285z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.826 7.648A1.433 1.433 0 0 1 11.4 6.211c0-.792.64-1.436 1.426-1.436.786 0 1.425.644 1.425 1.436 0 .793-.64 1.437-1.425 1.437zm0-3.828a2.384 2.384 0 0 0-2.376 2.386 2.384 2.384 0 0 0 2.376 2.387c1.31 0 2.375-1.07 2.375-2.387a2.384 2.384 0 0 0-2.375-2.386z"
});

var SvgOeil = function SvgOeil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 25 14",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOeil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oeil.2fec5f1d.svg";
export { ForwardRef as ReactComponent };